<template>
	<div class="notification-container">
		<div class="d-flex align-items-center justify-content-between gap-3 bg-white rounded8 p12 fsp16 lh24 neue">
			<span class="text-nowrap">{{ $t('components.service.Informator.25') }} 🔔</span> 
			<div @click="showNotificationPanel" class="menu-bg text-decoration-underline fsp16 lh24 neue">{{ $t('components.service.Informator.26') }}</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		showNotificationPanel() {
			this.$store.commit('SIDE_PANEL_SHOW', {
				title: 'Notification',
				content: {
					component: 'NotificationPanel',
					props: {}
				}
			});
			this.$store.commit('informator/SET_SHOW_NEW_NOTIFICATION', false);
		}
	},
	mounted() {
		setTimeout(() => {
			this.$store.commit('informator/SET_SHOW_NEW_NOTIFICATION', false);
		}, 4000);
	},
}
</script>

<style lang="scss" scoped>
.notification-container {
	position: fixed;
	top: 88px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 10000;
	width: 703px;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
	animation: ani 0.3s forwards;
	
	@media (max-width: 768px) {
		width: calc(100% - 48px);
	}
}
@keyframes ani {
	0% {opacity: 0;}
	100% {opacity: 1;}
}
</style>